import { RecursiveMenuModel } from './src/model/RecursiveMenuModel.js';
import { RecursiveMenuView } from './src/view/RecursiveMenuView.js';
import { addRecursiveMenuBlock } from './src/block/RecursiveMenuBlock.js';
import hoverBlock from './hoverBlock.js';

export default (editor, menuConfig) => {
    const defaultType = editor.DomComponents.getType('default');

    editor.DomComponents.addType('recursive-menu', {
        model: RecursiveMenuModel(defaultType.model, menuConfig, editor),
        view: RecursiveMenuView
    });

    addRecursiveMenuBlock(editor);
    hoverBlock(editor)
};